import { gql } from '@apollo/client';

export const GET_DELIVERY_TASK_ORDER_BY_TASK_ID = gql`
  query GetDeliveryTaskOrderByTaskId($deliveryTaskId: Long!) {
    getDeliveryTaskOrderByTaskId(deliveryTaskId: $deliveryTaskId) {
      id
      orderId
      trackingNumber
      receiverZipcode
      stopNumber
      subStopNumber
      routeName
      deliveryTaskId
      isPickedUp
      isDelivered
      isDelivery
    }
  }
`;

export interface DeliveryTaskOrderDetail {
  id: string;
  orderId: string;
  trackingNumber: string;
  receiverZipcode: string | null;
  stopNumber: number;
  subStopNumber: string;
  routeName: string | null;
  deliveryTaskId: string;
  isPickedUp: boolean;
  isDelivered: boolean;
  isDelivery: boolean;
}

export interface GetDeliveryTaskOrderByTaskIdResponse {
  getDeliveryTaskOrderByTaskId: DeliveryTaskOrderDetail[];
}

